var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c('section',_vm._l((_vm.content),function(element,index){return _c('FSXARenderContentElement',{key:element.id + '-' + index,attrs:{"element":element}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }